<template>
  <div class="cta-btn">
    <div class="try-now-btn">
      <span class="try-now-btn__label">Try Now: </span>
      <div class="try-now-btn__chips">
        <NuxtLink
          v-if="isPortrait ? !$isIPhone : true"
          class="try-now-btn__chip"
          href="https://play.google.com/store/apps/details?id=com.travvir.studio"
          target="_blank"
        >
          <NuxtImg
            :src="`${cdnUrl}/static/images/playstore-icon.png`"
            alt="Travvir Android App - Create Virtual Tours with Your Smartphone"
            width="100%"
            height="auto"
            fetch-priority="high"
            preload
          />
          <span>Android</span>
        </NuxtLink>
        <NuxtLink
          v-if="isPortrait ? $isIPhone : true"
          class="try-now-btn__chip"
          href="https://apps.apple.com/in/app/travvir-360-views-from-phone/id6443536819"
          target="_blank"
        >
          <NuxtImg
            :src="`${cdnUrl}/static/images/appstore-icon.png`"
            alt="Travvir iOS App - Create Virtual Tours with Your Smartphone"
            width="100%"
            height="auto"
            fetch-priority="high"
            preload
          />
          <span>iOS</span>
        </NuxtLink>
      </div>
    </div>
    <button class="contact-sales" @click="isFormModalOpen = true">
      Contact Sales
    </button>
  </div>
  <EnterpriseContact
    :is-enterprise="false"
    :show-form-modal="isFormModalOpen"
    :type-of-contact-form="msg"
    @close-form-modal="isFormModalOpen = false"
  />
</template>

<script setup>
const config = useRuntimeConfig();
const isPortrait = inject("isPortrait");
const cdnUrl = config.public.NUXT_CDN_URL;
defineProps({
  msg: {
    type: String,
    default: "",
  },
});
const isFormModalOpen = ref(false);
</script>

<style lang="scss" scoped>
.cta-btn {
  margin-top: 1.2rem;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  $cta-height: 2.75rem;
  .try-now-btn,
  .contact-sales {
    min-height: $cta-height;
    box-sizing: border-box;
    border-radius: 50px;
    font-family: "Sharp Grotesk";
    @include respond-below(sm) {
      min-height: 2.375rem;
    }
  }
  .try-now-btn {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 0.625rem;
    padding: 12px 20px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.1);
    pointer-events: auto;
    &:hover {
      background: rgba(255, 255, 255, 0.2);
      border: 1px solid rgba(255, 255, 255, 0.2);
    }
    @include respond-below(sm) {
      padding: 0.3rem 0.6rem 0.3rem 0.85rem;
      gap: 0.5rem;
    }
    &__label {
      flex-shrink: 0;
      font-size: 1rem;
      font-weight: 600;
      line-height: 1;
      letter-spacing: 0.02em;
      color: rgba(255, 255, 255, 1);
      white-space: nowrap;
      @include respond-below(sm) {
        font-size: 0.7rem;
      }
    }
    &__chips {
      display: flex;
      align-items: center;
      gap: 0.35rem;
    }
    &__chip {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 0.25rem;
      padding: 0.25rem 0.65rem;
      background: rgba(255, 255, 255, 1);

      border: 1px solid rgba(0, 0, 0, 0.08);
      border-radius: 999px;
      box-shadow:
        0 1px 2px rgba(0, 0, 0, 0.06),
        0 1px 3px rgba(0, 0, 0, 0.1);
      text-decoration: none;
      color: rgba(14, 14, 14, 0.9);
      font-size: 0.8125rem;
      font-weight: 500;
      line-height: 1;
      transition: all 0.2s ease;
      img {
        width: 14px;
        height: 14px;
        object-fit: contain;
        flex-shrink: 0;
      }
      &:hover {
        transform: translateY(-1px);
      }
      @include respond-below(sm) {
        padding: 0.2rem 0.55rem;
        font-size: 0.75rem;
        img {
          width: 13px;
          height: 13px;
        }
      }
    }
  }
  button {
    pointer-events: auto;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    padding: 12px 20px;
    font-weight: 500;
    font-size: 1rem;
    border-radius: 50px;
    transition: all 0.3s ease;
    &:hover {
      opacity: 1;
    }
    @include respond-below(sm) {
      font-size: 0.9rem;
      justify-content: center;
      padding: 8px 12px;
    }
  }
  .contact-sales {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: white;
    a {
      color: inherit;
      text-decoration: none;
    }
    &:hover {
      background: rgba(255, 255, 255, 0.2);
      border: 1px solid rgba(255, 255, 255, 0.2);
    }
  }
}
</style>
